import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './FacetFilter.css';
import {
  addFilter,
  removeFilter,
  addPendingFilter,
  removePendingFilter,
  selectAppliedFilters,
  selectPendingFilters,
  selectFacetData
} from '../store/filterSlice';

function FacetFilter({ filter, isOnResultPage = false }) {
  const [isExpanded, setIsExpanded] = useState(true);
  const [showAll, setShowAll] = useState(false);
  const dispatch = useDispatch();
  const appliedFilters = useSelector(selectAppliedFilters);
  const pendingFilters = useSelector(selectPendingFilters);
  const facetData = useSelector(selectFacetData);

  const fieldName = filter.value;
  const facetValues = facetData[fieldName]?.buckets || [];
  const appliedValues = appliedFilters[fieldName] || [];
  const selectedValues = isOnResultPage ? (pendingFilters[fieldName] || []) : appliedValues;
  const maxVisible = 5;

  const handleFilterToggle = (value) => {
    if (isOnResultPage) {
      // On result page, use pending filters
      if (selectedValues.includes(value)) {
        dispatch(removePendingFilter({ fieldName, value }));
      } else {
        dispatch(addPendingFilter({ fieldName, value }));
      }
    } else {
      // On landing page, apply immediately
      if (selectedValues.includes(value)) {
        dispatch(removeFilter({ fieldName, value }));
      } else {
        dispatch(addFilter({ fieldName, value }));
      }
    }
  };

  const visibleFacets = showAll ? facetValues : facetValues.slice(0, maxVisible);

  return (
    <div className="facet-filter">
      <div
        className="facet-header"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <h4 className="facet-title">{filter.label || fieldName}</h4>
        <svg
          className={`expand-icon ${isExpanded ? 'expanded' : ''}`}
          width="12"
          height="12"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <polyline points="6,9 12,15 18,9" />
        </svg>
      </div>

      {isExpanded && (
        <div className="facet-content">
          {facetValues.length === 0 ? (
            <p className="no-facets">No options available</p>
          ) : (
            <>
              <div className="facet-options">
                {visibleFacets.map((facet) => {
                  const isSelected = selectedValues.includes(facet.val);
                  const isApplied = appliedValues.includes(facet.val);
                  const isPending = isOnResultPage && isSelected && !isApplied;

                  return (
                    <label key={facet.val} className={`facet-option ${isApplied ? 'applied' : ''} ${isPending ? 'pending' : ''}`}>
                      <input
                        type="checkbox"
                        checked={isSelected}
                        onChange={() => handleFilterToggle(facet.val)}
                      />
                      <span className="facet-label">
                        {facet.val}
                        <span className="indicators">
                          {isApplied && (
                            <span className="applied-indicator" title="Currently applied">✓</span>
                          )}
                          {isPending && (
                            <span className="pending-indicator" title="Selected for application">●</span>
                          )}
                        </span>
                      </span>
                    </label>
                  );
                })}
              </div>

              {facetValues.length > maxVisible && (
                <button
                  className="show-more-button"
                  onClick={() => setShowAll(!showAll)}
                >
                  {showAll ? 'Show Less' : `Show ${facetValues.length - maxVisible} More`}
                </button>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default FacetFilter;